import { render, staticRenderFns } from "./OTParcelStatus.vue?vue&type=template&id=9368c322&scoped=true&"
import script from "./OTParcelStatus.vue?vue&type=script&lang=js&"
export * from "./OTParcelStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9368c322",
  null
  
)

export default component.exports